import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { childrenBusinessPageBreadcrumbs } from '../../config';
import { NavigateLinks, GlobalButton } from '@/components';
import { ReturnsIntakeFilters } from './models';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import {  
  QrCodeScanner as ScannerIcon,
  Assessment as MetricsIcon, 
  Inventory as PendingIcon,
  Report as NotReportedIcon
} from '@mui/icons-material';
import { 
  ReturnsIntakeSearchBar, 
  ReturnsIntakeTable,
} from './components';
import { 
  useReturnsIntakeFilter, 
  useReturnsIntakePagination, 
  useReturnsIntakes 
} from './hooks';

export const ReturnsIntake = () => {
  
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenBusinessPageBreadcrumbs(navigate),
    [navigate]
  );

  const { filter, setFilter, initialFilter } = useReturnsIntakeFilter(true, 'BUSINESS-RETURNS-INTAKE-FILTERS');
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } = useReturnsIntakePagination();

  const { returnsIntakes, isLoading, totalItems, totalPages } = useReturnsIntakes({
    filters: filter || {},
    page: currentPage,
    pageSize,
  });

  const handleSearch = (filters: ReturnsIntakeFilters) => {
    setFilter(filters);
    handlePageChange(1);
  };

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <NavigateLinks actualPage='Rendiciones' breadcrumbs={breadcrumbs} />
      <div className='flex justify-end gap-4'>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={() => navigate('/business/returns-intake/not-reported-shippings')}
        >
          <NotReportedIcon sx={{ color: '#ff7500' }} />
          Pedidos no reportados
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={() => navigate('/business/returns-intake/pending-shippings')}
        >
          <PendingIcon sx={{ color: '#ff7500' }} />
          Pedidos no rendidos
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={() => navigate('open-returns')}
        >
          <MetricsIcon sx={{ color: '#ff7500' }} />
          Conductores Sin Rendir
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => navigate('/business/returns-intake/scanner')}
        >
          <ScannerIcon />
          Escaneo de devoluciones
        </GlobalButton>
      </div>
      <ReturnsIntakeSearchBar
        search={handleSearch}
        initialFilter={initialFilter}
        filter={filter}
      />
      <ReturnsIntakeTable 
        returnsIntakes={returnsIntakes}
        isLoading={isLoading}
        totalItems={totalItems}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </section>
  );
};

export default ReturnsIntake;
